<template>
  <div>
    <div v-if="this.company" class="menu-items">
      <a
        class="cardTransactions cursor-pointer"
        :class="this.menuSelected.search && 'cardTransactions-active'"
        @click="goToMenu('support_beneficiaries_search')"
      >
        {{ $t("title.searchBeneficiaryName") }}
      </a>

      <a
        class="contact cursor-pointer"
        :class="this.menuSelected.beneficiary && 'contact-active'"
        @click="goToMenu('support_beneficiary')"
      >
        {{ $t("title.beneficiarySupportName") }}
      </a>

      <a
        class="amanage cursor-pointer"
        :class="this.menuSelected.account && 'amanage-active'"
        @click="goToMenu('support_account')"
      >
        {{ $t("title.settingsName") }}
      </a>
      <a href="#" class="logout" @click="logout()">{{ $t("title.logoutName") }}</a>
    </div>
    <div class="socials">
      <a href="https://www.facebook.com/UpRomania" class="facebook"></a>
      <a
        href="https://www.linkedin.com/company/up-romania"
        class="linkedin"
      ></a>
      <a
        href="https://www.youtube.com/c/UpRomaniaBucuresti"
        class="youtube"
      ></a>
    </div>
  </div>
</template>
<script>
import Cookies from "js-cookie";
import utils from "@/utils";

export default {
  name: "MenuItemsSupportBeneficiary",
  setup() {
    const { logoutCompany } = utils();
    return {
      logoutCompany
    }
  },
  props: {
    company: Object,
    menuSelected: {
      type: Object,
      default: () => ({
        search: false,
        beneficiary: false,
        account: false,
      }),
    },
    user: Object
  },
  components: {
  },
  data: function () {
  },
  methods: {
    mustStayOnBeneficiaryDetails() {
      const mustSave = sessionStorage.getItem("beneficiaryObservationsMustSave") === "true";
      const isOnBeneficiaryDetails = this.$route.name === "support_beneficiary";

      if (isOnBeneficiaryDetails && mustSave) {
        window.dispatchEvent(new Event("beneficiary-observations-required"));
        return true;
      }

      return false;
    },
    goToMenu(routeName) {
      if (this.mustStayOnBeneficiaryDetails()) {
        return;
      }

      if (this.$route.name !== routeName) {
        this.$router.push({ name: routeName });
      }
    },
    logout() {
      if (this.mustStayOnBeneficiaryDetails()) {
        return;
      }

      this.logoutCompany(this.user.id, Cookies.get("token"));
      Cookies.remove("userLink");
      Cookies.remove("token");
      Cookies.remove("selectedCompany");
      sessionStorage.removeItem('selectedCompany');

      this.$router.push({
        name: "login",
        params: { loginUserSelected: false }
      });
    },
    goBack() {
      window.history.length > 1 ? this.$router.go(-1) : this.$router.push("/");
    }
  },
};
</script>
<style scoped src="@/assets/styles/beneficiary.css"></style>
